import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
      
      // Debug logging - remove this after testing
      console.log('Scroll position:', scrollPosition, 'Is scrolled:', isScrolled);
    };

    // Call initially to set correct state
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  const handleHamburgerMenu = () => {
    const navBar = document.getElementById('nav-container');
    if (navBar.className === 'nav-container') navBar.className += " responsive";
    else navBar.className = "nav-container";
  }

  const handleResponsiveNavbar = () => {
    const navBar = document.getElementById('nav-container');
    if (navBar.className === 'nav-container responsive') navBar.className = "nav-container";
  }

  // Generate classes properly
  const navClasses = [
    'enmbl-navbar',
    isScrolled ? 'scrolled' : ''
  ].filter(Boolean).join(' ');

  console.log('Navbar classes:', navClasses); // Debug logging

  return (
    <nav className={navClasses}>
      <div className="nav-container" id="nav-container">
        <div className="nav-logo">enAblegames</div>
        <div className="nav-links">
          <NavLink to="/home" onClick={handleResponsiveNavbar}>HOME</NavLink>
          <NavLink to="/about" onClick={handleResponsiveNavbar}>ABOUT</NavLink>
          <NavLink to="/games" onClick={handleResponsiveNavbar}>GAMES</NavLink>
          <NavLink to="/features" onClick={handleResponsiveNavbar}>CLINIC FEATURES</NavLink>
          <NavLink to="/tech" onClick={handleResponsiveNavbar}>TECHNOLOGY</NavLink>
          <NavLink to="/support" onClick={handleResponsiveNavbar}>SUPPORT</NavLink>
          <NavLink to="/contact-us" onClick={handleResponsiveNavbar}>CONTACT US</NavLink>
          <motion.a 
            href="#portal" 
            className="portal-link"
            onClick={(e) => { e.preventDefault(); }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            CUSTOMER PORTAL
          </motion.a>
          <a href='#burger-menu' class='icon' onClick={handleHamburgerMenu}>
            ...
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;